import { useEffect, useState } from 'react'

const IS_BROWSER = typeof window !== 'undefined'


export const useIntersectionObserver = ({
    ref,
    options = { threshold: 0 },
    callback,
}) => {
    const [inView, setInView] = useState(false)

    const handleIntersect = (entries) => {
        if (!intersectObs) return
        // Otherwise, in situations where scrolling is **really** fast or the browser
        // is busy, we can consider that the last entry is the most up-to-date.
        const isIntersecting = entries[entries.length - 1].isIntersecting
        if (isIntersecting){
            callback?.(entries)
        }

        setInView(isIntersecting)
    }

    const [intersectObs] = useState(() =>
        IS_BROWSER ? new IntersectionObserver(handleIntersect, options) : undefined
    )

    useEffect(() => {
        if (!intersectObs) return

        intersectObs.observe(ref.current)

        return () => intersectObs.disconnect()
    }, [ref, intersectObs])

    return inView
}